import React, { useState } from "react";
import { Select, Input, Space  } from 'antd';
import FormItem from "components/fields/FormItem";

const SelectWithOthers = (props) => {
  	const { selectFieldName, selectOptions, selectDisplayValue,
  		othersFieldName, othersDisplayValue, mode, optionOthersId, onChangeHandler } = props;

	const [showOthers, setShowOthers] = useState(othersDisplayValue ? 'text' : 'hidden');
	const handleSelectChange = (value) => {
        setShowOthers(optionOthersId.includes(value) ? 'text' : 'hidden');
        if(onChangeHandler){
			onChangeHandler();
		}
    };
    
  	return (
		  <Space.Compact>         
            <FormItem className="font-medium mb-2"
            	name={selectFieldName}
                noStyle                
            >
            	{mode === 'edit' ?
            	<Select id={selectFieldName}
            		style={{
				        width: 250,
				      }}
				    options={selectOptions}
				    showSearch
            		allowClear={true}
            		onChange={handleSelectChange}
            	/>
                : <label className="ps-3 dark:text-white">{selectDisplayValue}</label>
                }
        	</FormItem>
            <FormItem className="font-medium mb-2"
            	name={othersFieldName}
                label="Others"
                noStyle
            >
            	{mode === 'edit' ?
            	<Input id={othersFieldName}
            		placeholder="Please specify"
            		type={showOthers}
            		style={{
				        width: 300,
				      }}
            	/>
                : <label className="ps-3 dark:text-white">{othersDisplayValue}</label>
                }
        	</FormItem>
        </Space.Compact>
  );
}

export default SelectWithOthers;
